import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

$(document).ready(function () {
  acfLookbooksBlock();
});

function acfLookbooksBlock() {
  $('.js-acf-lookbooks-block').each((_, block) => {
    const $list = $(block).find('.acf-lookbooks-block__list');
    const $buttonGroup = $(block).find('.acf-lookbooks-block__cats');

    // Init Isotope once per block
    const $iso = new Isotope($list[0], {
      itemSelector: '.lookbooks-item',
      layoutMode: 'fitRows',
      percentPosition: true,
      transitionDuration: '0.3s',
    });

    // Layout after images load
    imagesLoaded($list[0]).on('progress', () => $iso.layout());

    if ($buttonGroup) {
      // bind filter button click
      $buttonGroup.on('click', 'button', function () {
        let filterValue = $(this).attr('data-filter');
        $iso.arrange({ filter: filterValue });
      });

      // change is-active class on buttons
      $buttonGroup.on('click', 'button', function () {
        $buttonGroup.find('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
      });
    }
  });
}
